import React from 'react';

const ErrMessage = ({ text, inline }) => {
	return (
		<div
			style={inline ? { display: 'inline', marginLeft: '1rem' } : {}}
			className='error-message'>
			{text}
		</div>
	);
};

export default ErrMessage;
